// src/api_scripts/getholidaysList.js
import { fetchAllPages } from "../paginationUtils";

const getholidaysList = async (holidaysListName, orgId, accessToken, setProgress) => {
  const relativeUri = `organization/${orgId}/v2/holiday-list`;

  try {
    // Use the pagination utility to fetch all pages
    const holidaysListsArray = await fetchAllPages(relativeUri, accessToken, setProgress, "Holidays");
    console.log("Get Holiday List API Response Data (all pages):", holidaysListsArray.length, "items");
    return holidaysListsArray;

  } catch (error) {
    console.error(`Error fetching Holidays:`, error);
    throw error; // Re-throw the error to be caught by the calling function
  }
};

export default getholidaysList;
